import _ from "lodash";
import React from "react";

// @ts-ignore
import { Field } from "redux-form/dist/redux-form";
import type { BaseFieldProps, WrappedFieldProps } from "redux-form";

import Checkbox, { type CheckboxProps } from "./Checkbox";
import { generateFieldId, returnFieldState } from "./formMetaHelpers";


interface CheckboxFieldProps extends CheckboxProps, WrappedFieldProps {}

function CheckboxField({
  meta,
  input,
  disabled,
  help,
  children,
  fieldProps = {},
  ...restProps
}: CheckboxFieldProps) {

  const id = generateFieldId("checkbox", meta, restProps, input);
  const { isInvalid } = returnFieldState(meta);

  return (
    <Checkbox
      id={id}
      help={help}
      children={children}
      fieldProps={fieldProps}
      checked={input.checked || !!input.value}
      onChange={input.onChange}
      onFocus={input.onFocus}
      onBlur={input.onBlur}
      isInvalid={isInvalid}
      errorMessage={meta.error}
      disabled={meta.submitting || disabled}
      name={input.name}
      {...restProps} />
  );
}

// eslint-disable-next-line react/no-multi-comp
function CheckboxFieldHoc(props: CheckboxProps & BaseFieldProps) {

  return (
    <Field
      component={CheckboxField}
      {...props} />
  );
}

CheckboxFieldHoc.Checkbox = CheckboxField;

export default CheckboxFieldHoc;
